var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tooltip",
    {
      attrs: {
        effect: _vm.effect,
        content: _vm.text,
        placement: _vm.placement,
        disabled: _vm.isShowTooltip,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "text-ellipsis",
          class: _vm.className,
          on: { mouseover: _vm.onMouseOver },
        },
        [_c("span", { ref: "ellipsis" }, [_vm._v(_vm._s(_vm.text))])]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }